import React, { Fragment, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import cn from 'classnames';
import { graphql, compose } from 'react-apollo';
import { isEmpty } from 'lodash';
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import {
  isMCQ,
  getSingleResult,
  isRubric,
  isSecure,
} from 'legacy-src/utility/progressHelpers';
import LearnosityItemPreview from 'legacy/src/components/learnosity/LearnosityItemPreview';
import {
  createResponseAnalysis,
  customCbRubricsConfSetter,
  deserialiseScoringRubricResponses,
  getStudentResponseForItem,
} from 'legacy/src/components/learnosity/utils/helpers';
import ResultsItemHeader from 'legacy/src/components/assessment/Results/ResultsItemHeader/ResultsItemHeader';
import RelatedQuestions from 'legacy/src/components/assessment/Results/RelatedData/RelatedQuestions';
import ItemTags from 'legacy-src/utility/ItemTags';
import { trackItemResultsVisit } from 'legacy-src/queries';
import './index.scss';
import Rubrics from './Rubrics';
import RelatedItem from '../RelatedData/RelatedItem/RelatedItem';
import useAttestation from '../../hooks/useAttestation';
import { getPriorStudentsSubdir } from 'legacy-src/utility/utils';
import RelatedVideos from '../RelatedData/RelatedVideos';
import useCustomRubrics from 'legacy/src/components/learnosity/hooks/useCustomRubrics';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';
import useHideQuestionParts from './useHideQuestionParts';
const { keys } = Object;

const PerformanceItem = (props) => {
  const {
    params,
    isYourResult,
    itemRouteName,
    learnosityServerData,
    scoringRubricResponseAnalysis,
    learnosityReportsByItemData,
    location,
    routes,
    students: groupStudents,
    studentUrl,
    hasFrqQuestions,
    scoringRubric,
    router,
    learnosityReportsByRubricData = [],
    hideSidebar,
    learnosityReportsResponseAnalysisData,
    showTags,
    learnosityReportsData,
    meQuery: { me },
    isStudent,
    trackItemResultsVisitMutation,
    showQuestionNumbers,
    useQuestionNumberAsTitle,
    hideChartInNav,
    subjectData,
    showAttestationFlag,
    displaySkillsFlag,
    assignment,
    educationPeriod,
    progressPerStudent,
    showResults,
    studentContext,
    isPPC,
    isPerformanceTask,
    showRelatedVideosFlag,
    studentResponses,
    scoringRubricResponses,
    studentsSeeTeacherCreatedFF,
    retireQbQuestionsFF,
    pacingFlag,
    assessment,
  } = props;

  let { questions } = props;
  const { isSpp } = assessment || {};

  const [learnosityItems, setLearnosityItems] = useState([]);

  /**
   * Used to ensure if we watch an APD video and switch to a related question, we
   * keep the watched video marked as watched. It depended only on a watchedVideoIds prop to
   * the RelatedVideos component that got it from the BE when the component was mounted.
   */
  const [watchedVideosInSession, setWatchedVideosInSession] = useState([]);
  const [
    scoringRubricResponseAnalysisData,
    setScoringRubricResponseAnalysisData,
  ] = useState(Boolean(scoringRubricResponses));

  useEffect(() => {
    if (!isEmpty(scoringRubricResponses)) {
      setScoringRubricResponseAnalysisData(!isEmpty(scoringRubricResponses));
    }
  }, [scoringRubricResponses]);

  const currentQuestionId = params.questionId;
  const questionsById = questions.reduce((acc, current) => {
    acc[String(current?.id || '')] = current;
    return acc;
  }, {});
  const currentQuestion = questionsById[String(currentQuestionId)] || {};
  const questionOrder = router?.location?.state?.questionOrder || [];
  const originalQuestionIndex = questions.indexOf(currentQuestion);

  if ((questionOrder || []).length) {
    questions = Array.from(
      questionOrder,
      (questionId) => questionsById[String(questionId)],
    );
  }

  const { learnosityItemReference } = currentQuestion;
  const currentQuestionIndex = questions.indexOf(currentQuestion);
  const currentQuestionParts = currentQuestion.children || [];
  const { sectionId, students: assignmentStudents } = assignment;
  const students = assignmentStudents || groupStudents;

  const { partId } = params;
  const studentId = params.studentId || (me.isStudent && me.initId);

  const showStudentScores = !isEmpty(scoringRubricResponseAnalysis);

  useCustomRubrics({
    scoringRubricResponseAnalysis,
    assignment,
    progressPerStudent,
  });

  if (showStudentScores && scoringRubricResponses) {
    customCbRubricsConfSetter({
      data: deserialiseScoringRubricResponses(
        scoringRubricResponses,
        studentId,
      ),
      assignment,
      progressPerStudent,
    });
  }
  const redirectToFirstPartIfExists = () => {
    if (isPerformanceTask) {
      return;
    }
    if (!partId && currentQuestionParts && currentQuestionParts.length > 0) {
      const resultsPath = `${params.subject}/assessments/results/${
        params.assignmentId
      }${getPriorStudentsSubdir(routes)}`;
      const firstPartId = currentQuestionParts[0].id;
      const studentTeacherPath = isYourResult ? 'performance' : 'questions';
      const itemPath = `/${resultsPath}/${studentTeacherPath}/${currentQuestion.id}/parts/${firstPartId}`;
      router.replace(itemPath);
    }
  };

  redirectToFirstPartIfExists();

  const defineNavigation = () => {
    let prevQuestion =
      currentQuestionIndex > 0 ? questions[currentQuestionIndex - 1] : null;
    let nextQuestion =
      currentQuestionIndex < questions.length
        ? questions[currentQuestionIndex + 1]
        : null;
    let prevPart;
    let nextPart;

    const nextQuestionHasParts = nextQuestion && nextQuestion.children;
    const prevQuestionHasParts = prevQuestion && prevQuestion.children;
    let currentPartIndex = null;

    if (partId) {
      const currentPart = currentQuestionParts.find(
        (part) => part.id === partId,
      );
      currentPartIndex = currentQuestionParts.indexOf(currentPart);

      const isFirstPartInQuestion = currentPartIndex === 0;
      if (isFirstPartInQuestion) {
        prevPart =
          prevQuestionHasParts &&
          prevQuestion.children[prevQuestion.children.length - 1];
      } else {
        prevPart =
          currentQuestionParts && currentQuestionParts[currentPartIndex - 1];
        prevQuestion = currentQuestion;
      }

      const isLastPartInQuestion =
        currentPartIndex === currentQuestionParts.length - 1;
      if (isLastPartInQuestion) {
        nextPart = nextQuestionHasParts && nextQuestion.children[0];
      } else {
        nextPart =
          currentQuestionParts && currentQuestionParts[currentPartIndex + 1];
        nextQuestion = currentQuestion;
      }
    } else {
      prevPart =
        prevQuestionHasParts &&
        prevQuestion.children[prevQuestion.children.length - 1];
      nextPart = nextQuestionHasParts && nextQuestion.children[0];
    }
    return { prevQuestion, nextQuestion, prevPart, nextPart, currentPartIndex };
  };

  const { prevQuestion, nextQuestion, prevPart, nextPart, currentPartIndex } =
    defineNavigation();

  useHideQuestionParts(
    currentPartIndex,
    currentQuestionParts.length,
    true,
    !isEmpty(learnosityItems),
  );

  const onLearnosityReady = (app) => {
    if (app) {
      // Learnosity may create its viewport with scrollbars based on window height. We don't want that.
      app.questionsApp().setScrollablePassagesContextHeight('content');

      const questionsFromApp = app.questions();
      const items = app.getItems();

      // create array of items with questionsApi in array
      const itemsWithQuestions = keys(items).reduce((obj, reference) => {
        const currItem = items[reference];

        obj[reference] = {
          ...currItem,
          questionsWithApi: currItem.response_ids.map(
            (responseId) => questionsFromApp[responseId],
          ),
        };

        return obj;
      }, {});

      setLearnosityItems(itemsWithQuestions);
    }
  };

  const getCurrentItem = () => {
    if (partId && currentQuestionParts && currentQuestionParts.length > 0) {
      return currentQuestionParts.find((part) => part.id === partId);
    }

    return currentQuestion;
  };

  const currentItem = getCurrentItem();
  // currentItem can be rubric in FRQ, it does not have any is secure information
  const isSecureItem = isSecure(currentQuestion);
  const { isTopicQuestion } = currentQuestion || {};

  const { isAttestationEnabled, generateItemTitle } = useAttestation({
    subjectData,
    showAttestationFlag,
    isStudent: isYourResult,
    isSecureItem,
  });

  const isRubricItem = isRubric(currentItem);
  const reportToCheck = isRubricItem
    ? learnosityReportsByRubricData
    : learnosityReportsByItemData;
  const singleResult =
    getSingleResult(
      [studentId],
      currentItem.learnosityItemReference,
      reportToCheck,
    ) || {};
  const { learnosityReportScoreParsed, learnosityReportMaxScore } =
    singleResult;

  const teacherResultViewPurelyMCQs = !isYourResult && !hasFrqQuestions;

  useEffect(() => {
    if (params.questionId) {
      trackItemResultsVisitMutation();
    }
  }, [params.questionId]);

  const totalQuestions = questions.length;
  const showRubrics = scoringRubric && !teacherResultViewPurelyMCQs;
  const questionsOrder = useMemo(
    () => (props.questions || []).map((q) => q.id),
    props.questions,
  );

  return (
    <div
      className={cn('PerformanceItem question-preview-player', {
        'student-result': isYourResult,
      })}
    >
      <ResultsItemHeader
        isSPP={isSpp}
        result={{
          resultPath: '', // legacy
        }}
        location={location}
        params={params}
        routes={routes}
        router={router}
        students={students}
        studentUrl={studentUrl}
        item={currentQuestion}
        itemRouteName={itemRouteName}
        isYourResult={isYourResult}
        disableLinks // TODO: Add back later. Temporarily disable links. See FY-8423
        // disableLinks={disableLinks}
        learnosityReportsByItemData={
          partId ? learnosityReportsByRubricData : learnosityReportsByItemData
        }
        learnosityReportsByItemDataFull={learnosityReportsByItemData}
        prevQuestionId={prevQuestion ? prevQuestion.id : null}
        prevPartId={prevPart ? prevPart.id : null}
        nextQuestionId={nextQuestion ? nextQuestion.id : null}
        nextPartId={nextPart ? nextPart.id : null}
        learnosityReportScoreParsed={learnosityReportScoreParsed}
        learnosityReportMaxScore={learnosityReportMaxScore}
        isRubricItem={isRubricItem}
        showQuestionNumbers={showQuestionNumbers}
        hideChart={hideChartInNav}
        useQuestionNumberAsTitle={useQuestionNumberAsTitle}
        currentQuestionNumber={
          currentQuestion.order !== undefined
            ? currentQuestion.order + 1
            : originalQuestionIndex
        }
        currentQuestionIndex={currentQuestionIndex}
        totalQuestions={totalQuestions}
        showSecureIcon={isAttestationEnabled && isSecureItem}
        showTopicQuestionIcon={!isYourResult && isTopicQuestion}
        customTitle={generateItemTitle(currentQuestion, originalQuestionIndex)}
        displaySkillsFlag={displaySkillsFlag}
        showResults={showResults}
        me={me}
        studentsSeeTeacherCreatedFF={studentsSeeTeacherCreatedFF}
        retireQbQuestionsFF={retireQbQuestionsFF}
        pacingFlag={pacingFlag}
      />

      {learnosityServerData.request && (
        <Fragment>
          <div className="body">
            <div className="main-column">
              <div
                className={cn({
                  'learnosity-question-items': teacherResultViewPurelyMCQs,
                })}
              >
                {learnosityServerData.request.items.map((reference) => {
                  const learnosityQuestion =
                    learnosityItems[reference] &&
                    learnosityItems[reference].questionsWithApi[0];

                  return (
                    <LearnosityItemPreview
                      key={reference}
                      reference={reference}
                      isCurrent={learnosityItemReference === reference}
                      // multi-part support
                      // for MCQ there is one question per item, for FRQ there is TODO multi-question item
                      // for now grab the first and only one question
                      learnosityQuestion={learnosityQuestion}
                      areOptionsSelectable={!isYourResult && !studentId}
                      learnosityItem={learnosityItems[reference]}
                      // used in MCQOptions only response analysis workaround
                      studentResponsesForItem={getStudentResponseForItem(
                        studentResponses,
                        reference,
                        learnosityQuestion,
                      )}
                      // used in MCQOptions only
                      responseAnalysis={createResponseAnalysis(
                        learnosityReportsResponseAnalysisData,
                        reference,
                      )}
                      assignmentReport={learnosityReportsData}
                      students={students}
                      studentUrl={studentUrl}
                      studentId={studentId}
                      isMCQ={isMCQ(currentQuestion)}
                      isStudent={isStudent || params.studentId}
                      announceOptions={false}
                    />
                  );
                })}
              </div>

              {(showStudentScores
                ? showRubrics && scoringRubricResponseAnalysisData
                : showRubrics) && (
                <Rubrics
                  scoringRubric={scoringRubric}
                  question={currentQuestion}
                  findParentQuestion={(childRef) =>
                    questions.find(
                      (q) =>
                        q.children &&
                        q.children.find(
                          (child) => child.learnosityItemReference === childRef,
                        ),
                    )
                  }
                  partId={params.partId}
                  studentView={isYourResult}
                  assignmentReport={learnosityReportsData}
                  studentUrl={studentUrl}
                  learnosityReportsByRubricData={learnosityReportsByRubricData}
                  students={students}
                  showStudentCounts={!isYourResult && !studentId}
                />
              )}
            </div>

            {!hideSidebar && (
              <div className="sidebar">
                {currentQuestion.relatedSkills &&
                  !!currentQuestion.relatedSkills.length && (
                    <div className="related-data">
                      <div className="related-data-top">
                        <h3>Related Content & Skills</h3>
                      </div>
                      <ul>
                        {currentQuestion.relatedSkills.map((item, index) => (
                          <RelatedItem
                            item={item}
                            key={`${item.title}-${index}`}
                            data={currentQuestion.relatedSkills}
                            showPracticeQuestions={!isYourResult}
                            subjectId={params.subject}
                          />
                        ))}
                      </ul>
                    </div>
                  )}
                <RelatedQuestions
                  routes={routes}
                  params={params}
                  location={location}
                  isYourResult={isYourResult}
                  studentContext={studentContext}
                  isPPC={isPPC}
                  questionsOrder={questionsOrder}
                />
                {(showRelatedVideosFlag && (
                  <RelatedVideos
                    itemId={currentQuestion.id}
                    educationPeriod={educationPeriod}
                    studentContext={studentContext}
                    assignmentSectionId={Number.parseInt(sectionId, 10)}
                    router={router}
                    setWatchedVideosInSession={setWatchedVideosInSession}
                    watchedVideosInSession={watchedVideosInSession}
                    params={params}
                  />
                )) ||
                  null}
              </div>
            )}

            {showTags && !isStudent && (
              <ItemTags
                itemId={currentQuestionId}
                params={params}
                onLoad={(element) => setMathJaxTypeset(element)}
                educationPeriod={educationPeriod}
              />
            )}
          </div>

          <LearnosityProvider
            data-test-learnosity-provider
            apiType="items"
            className="learnosity-fallback"
            initOptions={learnosityServerData}
            readyListener={onLearnosityReady}
            containerElement="learnosity_assess_fallback"
          />
        </Fragment>
      )}
    </div>
  );
};

PerformanceItem.propTypes = {
  questions: PropTypes.array.isRequired,
  students: PropTypes.array,
  showTags: PropTypes.bool,
  isStudent: PropTypes.bool.isRequired,
  showQuestionNumbers: PropTypes.bool,
  useQuestionNumberAsTitle: PropTypes.bool,
  hideChartInNav: PropTypes.bool,
  hideSidebar: PropTypes.bool,
  showResults: PropTypes.bool,
};

PerformanceItem.defaultProps = {
  params: {},
  isYourResult: false,
  itemRouteName: 'ClassPerformanceItem',
  disableLinks: false,
  learnosityServerData: {},
  learnosityReportsByItemData: {},
  studentUrl: '',
  location: {},
  routes: [],
  students: [],
  showTags: false,
  hideChartInNav: false,
  useQuestionNumberAsTitle: false,
  showQuestionNumbers: false,
  hideSidebar: false,
  me: {},
  tagPairsData: {
    assignmentProgressWithTagPairs: {
      assessmentShortName: '',
      otherParts: [],
    },
  },
  showResults: true,
};

const withTrackItemResultsVisit = graphql(trackItemResultsVisit, {
  props: ({ mutate, ownProps }) => ({
    trackItemResultsVisitMutation: () =>
      mutate({
        variables: {
          assignmentId: ownProps.params.assignmentId,
          itemId: ownProps.params.questionId,
        },
      }),
  }),
});

function mapStateToProps(state) {
  const {
    subject: { data: subjectData },
    featureFlag,
  } = state;
  const {
    show_attestation_confirmation_dialog: showAttestationFlag,
    questions_list_skill_column: displaySkillsFlag,
    show_related_videos: showRelatedVideosFlag,
    students_see_teacher_created: studentsSeeTeacherCreatedFF,
    retire_qb_questions: retireQbQuestionsFF,
    pacing: pacingFlag,
  } = featureFlag;

  return {
    subjectData,
    showAttestationFlag,
    displaySkillsFlag,
    showRelatedVideosFlag,
    studentsSeeTeacherCreatedFF,
    retireQbQuestionsFF,
    pacingFlag,
  };
}

export default compose(
  withRouter,
  withTrackItemResultsVisit,
  connect(mapStateToProps),
)(PerformanceItem);
